import { TextArea } from "components/Atoms/formInputs/TextArea";
import React from "react";
import { replaceNewLineWithBr } from "utilities/reactUtils";

export interface OptionalTextAreaInputProps {
  value: string
  onChange: (newValue: string) => void

  maxLength: number
  onBlur?: (newValue: string) => void
  onCtrlEnter?: () => void
  onEsc?: () => void

  rows?: number
  placeholder?: string
  disabled?: boolean
  noResize?: boolean
  focusOnMount?: boolean

  fontFamily?: string
}

const OptionalTextAreaInput = (props: OptionalTextAreaInputProps) => {
  return <TextArea
    placeholder={props.placeholder}
    rows={props.rows || 6}
    value={props.value}
    onChange={props.onChange}
    maxLength={props.maxLength}
    onBlur={props.onBlur}
    onCtrlEnter={props.onCtrlEnter}
    onEsc={props.onEsc}
    disabled={props.disabled}
    noResize={props.noResize}
    focusOnMount={props.focusOnMount}
    fontFamily={props.fontFamily}
  />;
};

interface DetailProps {
  children: string;
}

export const OptionalTextAreaDetails = (props: DetailProps) => {
  return <div>{replaceNewLineWithBr(props.children || "")}</div>
}

export default OptionalTextAreaInput;